import { asyncTimeout } from 'utils/asyncTimeout';
import { SERVICES_MOCK_DELAY } from 'utils/constants';
import { SendTypingStatusService } from 'types/services';

export const sendTypingStatus: SendTypingStatusService = async () => {
  await asyncTimeout(SERVICES_MOCK_DELAY);
};
